import { useSelector } from "react-redux";
import useVideo from "../Hooks/useVideo";

const VideoContainer = ({ movieId }) => {
  //hook is called and moviId is passed
  useVideo(movieId);
  //In useVideo hook the video is already pushed to the store so now accessing
  const video = useSelector((store) => store?.movie?.videoBackground);
  if (video===null) return;
  const videoInfo = video[0]?.key;

  
 
  return (
    <div className=" w-[100%] aspect-video pt-10  sm:pt-0 lg:pt-0   bg-black ">
      <iframe
        className="w-full  aspect-video md:-mt-28 lg:-mt-32 xl:-mt-40"
        src={`https://www.youtube.com/embed/${videoInfo}?autoplay=1&mute=1&loop=1&playlist=${videoInfo}`}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default VideoContainer;
